import { EditorState, ContentState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import convertFromHTML from 'html-to-draftjs';
import { ConfigItem, ConfigGroup } from '../types/configuration';

export const parseTimeSpan = (value: string): [number, number, number, number] => {
  if (!value) return [0, 0, 0, 0];
  let totalSeconds = 0;
  if (value.includes(':')) {
    const parts = value.split(':').map(Number);
    while (parts.length < 4) parts.unshift(0);
    return [parts[0], parts[1], parts[2], parts[3]];
  } else {
    totalSeconds = Math.floor(Number(value));
    const days = Math.floor(totalSeconds / (24 * 3600));
    totalSeconds %= 24 * 3600;
    const hours = Math.floor(totalSeconds / 3600);
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return [days, hours, minutes, seconds];
  }
};

export const validateDays = (value: string): boolean => {
  const days = parseInt(value);
  return !isNaN(days) && days >= 0;
};

export const formatTimeSpan = (days: number, hours: number, minutes: number, seconds: number): string => {
  const formattedDays = days.toString().padStart(2, '0');
  const formattedHours = hours.toString().padStart(2, '0');
  const formattedMinutes = minutes.toString().padStart(2, '0');
  const formattedSeconds = seconds.toString().padStart(2, '0');
  return `${formattedDays}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};

export const findSelectedItem = (configGroups: ConfigGroup[], selectedItem: string): ConfigItem | null => {
  for (const group of configGroups) {
    const found = group.items.find((item) => item.id === selectedItem);
    if (found) return found;
  }
  return null;
};

export const syncEditorToHtml = (editorState: EditorState): string => {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
};

export const syncHtmlToEditor = (html: string): EditorState => {
  const contentBlocks = convertFromHTML(html);
  const contentState = ContentState.createFromBlockArray(contentBlocks.contentBlocks);
  return EditorState.createWithContent(contentState);
};

export const filterConfigGroups = (configGroups: ConfigGroup[], searchTerm: string): ConfigGroup[] => {
  return searchTerm
    ? configGroups.map((group) => ({
        ...group,
        items: group.items.filter(
          (item) =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.description.toLowerCase().includes(searchTerm.toLowerCase())
        ),
      })).filter((group) => group.items.length > 0)
    : configGroups;
};